import React from 'react';
import PropTypes from 'prop-types';

import SiteNavDropdownColumn from './SiteNavDropdownColumn';

import styles from './SiteNav-style.scss';

export const SiteNavPartialWidthDropdownContent = ({ moduleItems, trackingLabelPrefix }) => {
    const itemCols = moduleItems.reduce(
        (acc, moduleItem) => {
            const { type } = moduleItem;

            switch (type) {
                case 'primary':
                    acc.primary.push(moduleItem);
                    break;
                default:
                    acc.secondary.push(moduleItem);
            }
            return acc;
        },
        { primary: [], secondary: [] }
    );

    const { primary, secondary } = itemCols;

    return (
        <div className={`${styles.dropdownContent} ${styles.isPartialWidth}`}>
            {primary.length ? (
                <SiteNavDropdownColumn items={primary} trackingLabelPrefix={trackingLabelPrefix} />
            ) : null}
            {secondary.length ? (
                <SiteNavDropdownColumn
                    items={secondary}
                    trackingLabelPrefix={trackingLabelPrefix}
                />
            ) : null}
        </div>
    );
};

SiteNavPartialWidthDropdownContent.propTypes = {
    moduleItems: PropTypes.array,
    trackingLabelPrefix: PropTypes.string,
};
